module.exports = __webpack_public_path__ + "img/github.728a0781.svg";